'use strict';exports.__esModule = true;exports.hideReportIssueModal = exports.openReportIssueModal = exports.resetData = exports.reportIssue = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var resetData = (0, _reduxAct.createAction)('/RESET_DATA');
var reportIssue = (0, _reduxAct.createAction)('/REPORT_ISSUE');
var reportIssueSuccess = (0, _reduxAct.createAction)('/REPORT_ISSUE_SUCCESS');
var reportIssueFail = (0, _reduxAct.createAction)('/REPORT_ISSUE_FAIL');
var openReportIssueModal = (0, _reduxAct.createAction)('/OPEN_REPORT_ISSUE_MODAL');
var hideReportIssueModal = (0, _reduxAct.createAction)('/HIDE_REPORT_ISSUE_MODAL');

var initialState = {
  sending: false,
  sent: false,
  error: null,
  reportModalIsOpen: false };


var handleResetData = function handleResetData(state) {return Object.assign({},
  state,
  initialState);};


var fetchReport = function fetchReport(data) {return _axios2.default.post('/mailing/report', data).
  then(reportIssueSuccess, reportIssueFail);};

var reportHandler = function reportHandler(state, data) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    sending: true,
    sent: false,
    error: null }),
  promise(fetchReport, data));};

var reportHandlerSuccess = function reportHandlerSuccess(state, response) {return Object.assign({},
  state, {
    sending: false,
    sent: true,
    data: response && response.data });};


var reportHandlerFail = function reportHandlerFail(state, action) {
  (0, _formatApiError2.default)(action, 'Failed reporting issues');
  return Object.assign({},
  state, {
    sending: false,
    sent: false,
    data: undefined,
    error: action });

};

var handleOpenReportIssueModal = function handleOpenReportIssueModal(state, _ref) {var issueType = _ref.issueType,reportType = _ref.reportType;return Object.assign({},
  state, {
    reportModalIsOpen: true,
    types: {
      issueType: issueType,
      reportType: reportType } });};


var handleHideReportIssueModal = function handleHideReportIssueModal(state) {return Object.assign({},
  state, {
    reportModalIsOpen: false });};


var reportIssues = (0, _reduxAct.createReducer)(function (on) {
  on(reportIssue, reportHandler);
  on(reportIssueSuccess, reportHandlerSuccess);
  on(reportIssueFail, reportHandlerFail);
  on(resetData, handleResetData);
  on(openReportIssueModal, handleOpenReportIssueModal);
  on(hideReportIssueModal, handleHideReportIssueModal);
}, initialState);exports.


reportIssue = reportIssue;exports.
resetData = resetData;exports.
openReportIssueModal = openReportIssueModal;exports.
hideReportIssueModal = hideReportIssueModal;exports.default =


reportIssues;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reportIssues.js
// module id = 278
// module chunks = 0